var _style, _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRokuDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 311.16595,
    width: 1000,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .logo {\n          fill: #9e7bc9;\n        }\n    ")), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m430.311 715.04h163.689v76.96h-163.689z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    className: "logo",
    transform: "matrix(7.55785275 0 0 -7.55785275 -3370.793585 5860.60125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 3.755-3.021 6.779-6.715 6.779h-3.33v-13.498h3.33c3.694 0 6.715 3.026 6.715 6.719m15.148-26.909h-12.224l-9.705 13.468h-3.264v-13.439h-10.773v40.374h15.433c8.897 0 16.159-6.05 16.159-13.494 0-4.54-2.784-8.595-7.021-11.076z",
    transform: "translate(466.883 761.8719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.845 0-5.265-3.867-5.265-8.654s2.42-8.659 5.265-8.659c2.911 0 5.327 3.872 5.327 8.659s-2.416 8.654-5.327 8.654m16.582-8.654c0-9.145-7.437-16.468-16.582-16.468-9.142 0-16.524 7.323-16.524 16.468 0 9.138 7.382 16.465 16.524 16.465 9.145 0 16.582-7.327 16.582-16.465",
    transform: "translate(494.1805 759.449)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-12.41-12.408v12.449h-10.771v-31.639h10.771v12.834l12.956-12.834h13.557l-16.464 16.466 13.637 13.632v-18.776c0-6.234 3.749-11.987 13.19-11.987 4.482 0 8.595 2.542 10.594 4.842l4.843-4.177h2.299v31.598h-10.771v-16.462-3.996c-1.213-2.117-2.903-3.448-5.515-3.448-2.65 0-3.866 1.571-3.866 6.596v1.326 15.984z",
    transform: "translate(536.0434 766.5903)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRokuDark);
export default __webpack_public_path__ + "static/media/roku-dark.157ec6cc06b36c0290fdb02e1774260d.svg";
export { ForwardRef as ReactComponent };